module.exports = __webpack_public_path__ + "assets/08be5936d38e8a0792697c25f81fa200.png";